<template>
  <div class="left-chart-3" id="left-chart-3"></div>
</template>

<script>
import { querysbwxbycs } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const echartsDom = document.getElementById('left-chart-3')
      this.chart = this.$echarts.init(echartsDom)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const apiData = await querysbwxbycs(this.date)
      let yDatas = []
      let byDatas = []
      let wxDatas = []
      apiData.forEach(item => {
        if (item) {
          yDatas.push(item.assets_type)
          byDatas.push(item.whljwx_bycs)
          wxDatas.push(item.whljwx_wxcs)
        }
      })
      const options = {
        title: {
          text: '设备维修保养次数',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          bottom: 0,
          left: 'center',
          data: ['保养次数', '维修次数'],
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: 40,
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          data: yDatas,
        },
        series: [
          {
            name: '保养次数',
            type: 'bar',
            data: byDatas,
          },
          {
            name: '维修次数',
            type: 'bar',
            data: wxDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-3 {
  width: 100%;
  height: 33%;
  display: flex;
  flex-direction: column;
}
</style>
